import React, { useMemo, useState } from "react";
import type { TAttachment } from "@atlas/tool/box/file/types";
import createPreviewUrl from "@atlas/tool/box/file/createPreviewUrl";
import Image from "next/image";
import styled from "styled-components";
import getExtensionFromUrl from "@atlas/tool/box/file/getExtensionFromUrl";
import FileEmptyIcon from "@atlas/uicorn/lib/Icon/FileEmptyIcon";

const DISPLAYED_HEIGHT = 100;

const AttachmentPreview = function AttachmentPreview({
  attachment,
}: {
  attachment: TAttachment;
}) {
  const [failed, setFailed] = useState(false);
  const { handle, url } = attachment;
  const extension = useMemo(() => getExtensionFromUrl(url), [url]);
  const previewUrl = useMemo(
    () => createPreviewUrl({ handle, url }, DISPLAYED_HEIGHT),
    [handle, url]
  );

  if (!attachment.handle || failed) {
    return <div title={extension}>{extension || <FileEmptyIcon />}</div>;
  }

  return (
    <SImageContainer>
      <Image
        loading="lazy"
        layout="fill"
        objectFit="contain"
        src={previewUrl}
        alt={attachment.name}
        onError={() => setFailed(true)}
      />
    </SImageContainer>
  );
};

export default AttachmentPreview;

const SImageContainer = styled.div`
  position: relative;
  height: ${() => `${DISPLAYED_HEIGHT}px`};
`;
